import { SPINNER_SET, SPINNER_UNSET } from 'actions/actionTypes';

interface ActionType {
  type: 'SPINNER_SET' | 'SPINNER_UNSET';
}

export default (state = false, action: ActionType): boolean => {
  switch (action.type) {
    case SPINNER_SET:
      return true;
    case SPINNER_UNSET:
      return false;
    default:
      return state;
  }
};
